import { EntityInput, LinkProps } from "helpers/url";

export function brandHref(): LinkProps["href"] {
  return { pathname: "/brand/[...all]" };
}

export function brandAs(entity: EntityInput): LinkProps["as"] {
  if (entity.url) return entity.url;
  return `/brand/${entity.alias}/`;
}
